module.exports = __webpack_public_path__ + "static/t1-d588fd9c58142f2c39938d6aab4ad284.mp4";